import React from 'react';
import Paper from '@material-ui/core/Paper';

import { useStyles } from './styles';

const FormHeader = React.memo(({ name, description }: any) => {
    const classes = useStyles();
    return (
        <div>
            <Paper classes={{ root: classes.formHeaderRoot }} elevation={0}>
                <div className={classes.title}>{name}</div>
                <div className={classes.description}>{description}</div>
                {/*<div className={classes.required}>* Required</div>*/}
            </Paper>
        </div>
    );
});

export default FormHeader;
